export class GlobalConstants {
    
      
    public static siteTitle: string ;
    public static LoginLogoPath: string;
    public static SiteLogoPath: string ;
    public static SiteSecondLogoPath: string ;
    public static HomePageImagePath: string ;
    public static AppName: string ;
    public static FooterText: string ;

  static  Initialize()
    {
        this.siteTitle = "MFANO";
        this.LoginLogoPath  = "./assets/images/SiteImages/LoginLogo.png";
        this.SiteLogoPath  = "assets/images/SiteImages/Logo.png";
        this.SiteSecondLogoPath  = "assets/images/SiteImages/Logo.png";
        this.HomePageImagePath  = "assets/images/SiteImages/HomePage.png";
        this.AppName  = "MFANO" ;
        this.FooterText  = "2023 MFANO " ;
        
    }
}